import { render, staticRenderFns } from "./grading_details_form.vue?vue&type=template&id=67dccf7d&scoped=true&"
import script from "./grading_details_form.vue?vue&type=script&lang=js&"
export * from "./grading_details_form.vue?vue&type=script&lang=js&"
import style0 from "./grading_details_form.vue?vue&type=style&index=0&id=67dccf7d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dccf7d",
  null
  
)

export default component.exports